module.exports = __webpack_public_path__ + "static/hose.35f0c087.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/javascript-roundup/hose.gif
// module id = 604
// module chunks = 43363949817824